var exports = {
  "a": "Box__lS6coW",
};

module.exports = exports;
